import FeatureGate from "@/src/components/feature-gate";
import WikiFeedbackScreen from "@/src/screens/wiki/wiki-feedback-screen/wiki-feedback-screen";

export default function WikiFeedback() {
  return (
    <FeatureGate feature="feedback">
      <WikiFeedbackScreen />
    </FeatureGate>
  );
}
